import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import { ampli } from 'src/ampli';

let isSessionReplayInitialized = false;

export const initializeAmplitudeSessionReplay = async (
    ampliLoadPromise: Promise<void> | undefined
    , debugMode: boolean
) => {
    if ( isSessionReplayInitialized ) {
        return;
    }

    isSessionReplayInitialized = true;

    try {
        await ampliLoadPromise;

        ampli.client.add( sessionReplayPlugin( {
            sampleRate: process.env.NEXT_PUBLIC_AMPLITUDE_SESSION_REPLAY_SAMPLE_RATE ? parseFloat( process.env.NEXT_PUBLIC_AMPLITUDE_SESSION_REPLAY_SAMPLE_RATE ) : 0
            , debugMode
            , privacyConfig: {
                defaultMaskLevel: 'medium'
            }
        } ) );
    } catch ( error ) {
        console.error( 'Failed to initialize Amplitude Session Replay', error );
    }
};
